import dynamic from "next/dynamic";
import UseCasesTabsConfig from "./use-cases-tabs-config";
import UseCasesTabsAdvancedConfig from "./use-cases-tabs-advanced-config";
const UseCasesTabsComponent = dynamic(()=>import("./use-cases-tabs-component"));
export default {
    UseCasesTabsComponent,
    UseCasesTabsConfig,
    UseCasesTabsAdvancedConfig
};
